import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'clsx';
import mint from '@tunein/mint';
import get from 'lodash/get';
import DialogDisplayAd from './DialogDisplayAd';
import css from './now-playing-dialog-ad.module.scss';

const AD_SLOT_NAME_AND_ID = 'nowPlaying_side';

export class NowPlayingDialogAd extends Component {
  static propTypes = {
    matchUrl: PropTypes.string.isRequired,
    guideId: PropTypes.string,
    loadedDisplaySlotId: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = { isAdOpen: false };
    this.handleAdClose = this.handleAdClose.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { loadedDisplaySlotId } = this.props;

    if (
      prevProps.loadedDisplaySlotId !== loadedDisplaySlotId &&
      loadedDisplaySlotId === AD_SLOT_NAME_AND_ID
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ isAdOpen: true });
    }
  }

  handleAdClose() {
    mint.clearSlot(AD_SLOT_NAME_AND_ID, true);
    this.setState({ isAdOpen: false });
  }

  render() {
    const { matchUrl, guideId } = this.props;

    const { isAdOpen } = this.state;

    return (
      <div
        data-testid="adOverlay"
        className={classNames({
          [css.adOverlay]: isAdOpen,
          [css.hiddenAdOverlay]: !isAdOpen,
        })}
      >
        <div className={css.adInnerContainer}>
          <div
            data-testid="closeIconContainer"
            className={css.adCloseIconContainer}
          >
            <i
              data-testid="adCloseIcon"
              className={css.adCloseIcon}
              onClick={this.handleAdClose}
            />
          </div>
          <DialogDisplayAd
            id={AD_SLOT_NAME_AND_ID}
            slotName={AD_SLOT_NAME_AND_ID}
            isProfile={false}
            matchUrl={matchUrl}
            guideId={guideId}
            className={css.ad}
          />
        </div>
      </div>
    );
  }
}

export function mapStateToProps(state) {
  return {
    loadedDisplaySlotId: get(state, 'mint.loadedDisplaySlotId', ''),
  };
}

export default connect(mapStateToProps)(NowPlayingDialogAd);
